import './Statistics.scss';
import { Ball } from '../../platform/components/ball/Ball';
import { observer } from 'mobx-react';
import { gameStore } from '../../platform/stores';

export const Statistics = observer(() => {
  const { statistics } = gameStore;
  const data = Object.keys(statistics);
  const maxValue = Math.max(...Object.values(statistics));

  return (
    <div className="statistics-component">
      {
        data.map((item) =>
          <div className="statistics-item" key={item}>
            <Ball number={+item} width={50} fontSize={23}/>
            <div className="progress-bar">
              <div className="progress" style={{ width: statistics[+item] / maxValue * 100 + '%' }}></div>
            </div>
            <div className="number">{statistics[+item]}</div>
          </div>
        )
      }
    </div>
  );
});
